import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as globals from '@reusable/services/globals';
import { Observable } from 'rxjs';

@Injectable()
export class TeamCoreModelsService {
  responseData: any;

  constructor(private httpClient: HttpClient, private gtn: globals.GetTokenNow) {}

  listModels(sort, records, pageNumber, queries?): Observable<any> {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/models/list/sortBy-${sort}/${records}/${pageNumber}/`, updateQueries)
      .pipe(map(res => res as any));
  }

  viewModel(modelId) {
    return this.httpClient.get(`${globals.domain}/core/models/${modelId}/view`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  updateModel(modelId, body) {
    return this.httpClient
      .put(`${globals.domain}/core/models/${modelId}/update/`, JSON.stringify(body), this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
  rearrangeModel(body) {
    return this.httpClient.put(`${globals.domain}/core/models/rearrange/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  editModel(modelId) {
    return this.httpClient.get(`${globals.domain}/core/models/${modelId}/edit/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  addModel(body) {
    return this.httpClient.post(`${globals.domain}/core/models/add/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  removeModel(modelId) {
    return this.httpClient.delete(`${globals.domain}/core/models/${modelId}/remove/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  restoreModel(modelId) {
    return this.httpClient.put(`${globals.domain}/core/models/${modelId}/restore/`, {}, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
}